;(() => {
  const searchForms = document.querySelectorAll('form#search-form')
  if (!searchForms.length) return

  const handleKeyup = debounce(async function (event, formInstance) {
    const query = event.target.value
    if (query.length < 3) return
    shopifyPredictiveSearch(query, formInstance)
  })

  async function shopifyPredictiveSearch(query, formInstance) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}search/suggest?q=${query}&section_id=search-dropdown&resources[options][fields]=product_type,tag,title,variants.title,variants.sku`
      )
      const responseHtml = await response.text()
      formInstance.querySelector('#search-dropdown').innerHTML = responseHtml
    } catch (error) {
      console.error('shopify search error:', error)
      if (window.Sentry) {
        Sentry.captureException(error, { tags: { function: 'shopifySearch' } })
      }
    }
  }

  function debounce(func, timeout = 500) {
    let timer
    return (...args) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        func.apply(this, args)
      }, timeout)
    }
  }

  searchForms.forEach((form) => {
    form
      .querySelector('input[type="search"]')
      .addEventListener('keyup', (event) => handleKeyup(event, form))
  })

  document
    .querySelector('button#toggle-search-mobile')
    .addEventListener('click', function () {
      const panel = document.querySelector('.mobile-search')
      if (this.classList.contains('active')) {
        this.classList.remove('active')
        panel.classList.remove('active')
      } else {
        this.classList.add('active')
        panel.classList.add('active')
        document.querySelector('.mobile-search input[type="search"]').focus()
      }
    })
})()
